const sessionRoutes = [
  {
    path: ":phase",
    redirect: (to: { params: any }) => ({ name: "decisions", params: to.params }),
  },
  {
    path: ":phase/decisions",
    name: "decisions",
    component: () => import("@/pages/session/decisions.vue"),
  },
  {
    path: ":phase/voters",
    name: "voters",
    component: () => import("@/pages/session/voters.vue"),
  },
];

export const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/index.vue"),
  },
  {
    path: "/session/:session",
    name: "session",
    component: () => import("@/pages/session/index.vue"),
    children: sessionRoutes,
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/pages/settings/index.vue"),
  },
  {
    path: "/bodies",
    name: "bodies",
    component: () => import("@/pages/bodies/index.vue"),
  },
  {
    path: "/body/:id",
    name: "body",
    component: () => import("@/pages/bodies/body.vue"),
  },
  {
    path: "/organisations",
    name: "organisations",
    component: () => import("@/pages/organisations/organisations.vue"),
  },
  {
    path: "/countries",
    name: "countries",
    component: () => import("@/pages/countries/countries.vue"),
  },
  {
    path: "/download/:id",
    name: "download-document",
    component: () => import("@/pages/download/document.vue"),
  },
  {
    path: "/503",
    name: "503",
    component: () => import("@/pages/errors/503.vue"),
  },
];
